import { Stack } from "@mui/material";
import { ShieldIcon } from "@src/appV2/redesign/EmergencyCredits/components/ShieldIcon";
import { ShieldWithSlashIcon } from "@src/appV2/redesign/EmergencyCredits/components/ShieldWithSlashIcon";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface CancellationCreditStatusCardProps {
  hasCredit: boolean;
  shiftsUntilNextCredit: number;
}

export function CancellationCreditStatusCard(props: CancellationCreditStatusCardProps) {
  const { hasCredit, shiftsUntilNextCredit } = props;

  const title = hasCredit
    ? "Same-day cancellation credit available"
    : "Same-day cancellation credit already used";

  const shiftLabel = shiftsUntilNextCredit === 1 ? "shift" : "shifts";
  const description = hasCredit
    ? "You've earned yourself some flexibility! Your next 24h cancellation will cost less."
    : `You've recently used this credit. Late cancellations cost more for the next ${shiftsUntilNextCredit} ${shiftLabel}.`;

  return (
    <Stack sx={{ flexDirection: "column", gap: 3 }}>
      <Stack sx={{ alignItems: "center", flexDirection: "row", gap: 2 }}>
        {hasCredit ? (
          <ShieldIcon variant="outlined" sx={{ fontSize: "1.25rem" }} />
        ) : (
          <ShieldWithSlashIcon sx={{ fontSize: "1.25rem" }} />
        )}
        <Text
          semibold
          variant="body1"
          sx={(theme) => ({
            // eslint-disable-next-line no-restricted-syntax -- Blue color matching ShieldIcon gradient from Figma design
            color: hasCredit ? "#4B6AA6" : theme.palette.intent?.error.text,
          })}
        >
          {title}
        </Text>
      </Stack>

      <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {description}
      </Text>
    </Stack>
  );
}
